import React, { useState, useEffect, useContext } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getModuleById } from '../api';
import { RedirectUrlValue } from '../../context/RedirectUrlValue.js';
import "../../styles/Contact.css"
import { safeHtml } from "./safeHtml";

export default function Contact() {
    
    const { state } = useLocation();
    const [error, setError] = useState(null);
    const [module, setModule] = useState({});
    const { brand } = useContext(RedirectUrlValue);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const moduleData = await getModuleById(state?.module);
                setModule(moduleData);
            } catch (error) {
                setError('Une erreur s\'est produite lors de la récupération des données.');
            }
        };
        fetchData();
    }, [brand, state?.module])

    useEffect(() => {
        if(error) {
            console.log(error)
            navigate("/");
        }
    }, [error, navigate])

    // Sans state (rafraîchissement, URL partagée, retour arrière), ce module
    // plantait à l'affichage. On revient à l'accueil du client.
    if (!state?.module) return <Navigate to="/mainpage" replace />;

    return(
        <div className='Wiew page WiewState'>
            <div className="titlePage">
                <img src={module.imageUrl} alt="" />
                <div className="centerTexte">
                    <h3>{module.title}</h3>
                </div>
            </div>
            <p dangerouslySetInnerHTML={{ __html: safeHtml(module.text) }}></p>        
        </div>
    )
}